// DOM güvenlik yardımcı fonksiyonları
export class DOMSafetyUtils {
  
  /**
   * Güvenli className.split işlemi
   */
  static safeClassNameSplit(element: Element | null): string[] {
    if (!element) return [];
    
    try {
      const className = element.className;
      
      // className string değilse boş array döndür
      if (typeof className !== 'string') {
        return [];
      }
      
      // Boş string kontrolü
      if (!className || className.trim() === '') {
        return [];
      }
      
      return className.split(/\s+/).filter(cls => cls.length > 0);
    } catch (error) {
      console.warn('DOMSafetyUtils: className.split error:', error);
      return [];
    }
  }

  /**
   * Güvenli element selector oluşturma
   */
  static getElementSelector(element: Element | null): string {
    if (!element) return '';
    
    try {
      const tagName = element.tagName?.toLowerCase() || '';
      const id = element.id ? `#${element.id}` : '';
      const classes = this.safeClassNameSplit(element);
      const classSelector = classes.length > 0 ? `.${classes.join('.')}` : '';
      
      return `${tagName}${id}${classSelector}`;
    } catch (error) {
      console.warn('DOMSafetyUtils: getElementSelector error:', error);
      return 'unknown-element';
    }
  }

  /**
   * Güvenli DOM event listener
   */
  static addSafeEventListener(
    element: Element | Document | Window | null,
    event: string,
    handler: EventListener,
    options?: AddEventListenerOptions
  ): () => void {
    if (!element || typeof element.addEventListener !== 'function') {
      return () => {}; // No-op cleanup function
    }

    try {
      element.addEventListener(event, handler, options);
      
      // Cleanup function döndür
      return () => {
        try {
          element.removeEventListener(event, handler, options);
        } catch (error) {
          console.warn('DOMSafetyUtils: removeEventListener error:', error);
        }
      };
    } catch (error) {
      console.warn('DOMSafetyUtils: addEventListener error:', error);
      return () => {};
    }
  }

  /**
   * Element varlık kontrolü
   */
  static isValidElement(element: any): element is Element {
    return element && 
           typeof element === 'object' && 
           element.nodeType === Node.ELEMENT_NODE &&
           typeof element.tagName === 'string';
  }
}

// Global error handler için DOM hatalarını yakala
if (typeof window !== 'undefined') {
  // Element.prototype.className getter'ını güvenli hale getir
  const originalClassNameDescriptor = Object.getOwnPropertyDescriptor(Element.prototype, 'className');
  
  if (originalClassNameDescriptor) {
    Object.defineProperty(Element.prototype, 'className', {
      get: function() {
        try {
          const result = originalClassNameDescriptor.get?.call(this);
          return typeof result === 'string' ? result : '';
        } catch (error) {
          console.warn('className getter error:', error);
          return '';
        }
      },
      set: originalClassNameDescriptor.set,
      enumerable: true,
      configurable: true
    });
  }

  // Global className.split hatalarını yakala
  const originalSplit = String.prototype.split;
  String.prototype.split = function(separator?: string | RegExp, limit?: number) {
    try {
      return originalSplit.call(this, separator, limit);
    } catch (error) {
      console.warn('String.split error caught:', error);
      return [];
    }
  };

  const originalAddEventListener = Document.prototype.addEventListener;
  
  Document.prototype.addEventListener = function(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions) {
    const safeListener = (event: Event) => {
      try {
        if (typeof listener === 'function') {
          listener(event);
        } else if (listener && typeof listener.handleEvent === 'function') {
          listener.handleEvent(event);
        }
      } catch (error) {
        console.warn('DOM Event Handler Error:', error);
        
        // className.split hatası özel kontrolü
        if (error instanceof TypeError && error.message.includes('className.split')) {
          console.warn('className.split error detected - using safe fallback');
        }
      }
    };
    
    return originalAddEventListener.call(this, type, safeListener, options);
  };
}
